import AboutUs from "../../Components/About/about";
import AboutUs1 from '../../Components/About/about1';
import MissionVision from '../../Components/About/mission';
import Process from '../../Components/Home/process';
import Client from '../../Components/Home/client';
import SEO from "../seo";

function AboutPage() {

  const pageKeywords = [
    "react website",
    "static pages",
    "web development",
    "SEO services"
  ];
  return (
    <>
      <SEO
        title="Horizon WebInfo Pvt Ltd known as HWPL, your trusted partner in the ever-evolving landscape of Information Technology."
        description="Horizon Webinfo Pvt Ltd, a leading website development company in Ahmedabad, India, boasts over 18 years of experience crafting exceptional websites tailored for businesses and their target audiences. Their skilled team of developers, designers, and digital marketing experts collaborate to deliver innovative web solutions encompassing:"
        canonical="https://www.hwplindia.com/company/about-us/"
        ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/mobile-app-development-company-banner-img.png"
        keywords={pageKeywords}
      />
      <AboutUs />
      <AboutUs1 />
      <Process />
      <MissionVision />
      <Client />
    </>
  );
}

export default AboutPage;
